// MUI
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// Icons
import TwitterIcon from "@mui/icons-material/Twitter";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import RedditIcon from "@mui/icons-material/Reddit";
import EmailIcon from "@mui/icons-material/Email";
import TelegramIcon from "@mui/icons-material/Telegram";
// import FacebookMessangerIcon from './icon/FacebookMessangerIcon'

// Styles
const body = {
  align: "left",
  marginTop: "2vh",
  marginBottom: "2vh",
};

const button = {
  marginTop: "8px",
  marginRight: "8px",
};

const SocialShareButtons = (props) => {
  const urlEncodedTitle = encodeURIComponent(props.title);

  const twitterShareUrl = `https://twitter.com/intent/tweet?&url=${props.url}`;
  const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${props.url}`;
  const pintrestShareUrl = `https://pinterest.com/pin/create/button/?url=${props.url}&media=&description=`;
  const linkedinShareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${props.url}`;
  const redditShareUrl = `http://www.reddit.com/submit?url=${props.url}&title=${urlEncodedTitle}`;
  const mailToUrl = `mailto:info@example.com?&subject=&cc=&bcc=&body=${props.url}%0A`;
  const telegramShareUrl = `https://t.me/share/url?url=${props.url}&text=${urlEncodedTitle}`;

  return (
    <Box sx={body}>
      <a href={twitterShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <TwitterIcon fontSize="large" />
        </Button>
      </a>
      <a href={facebookShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <FacebookIcon fontSize="large" />
        </Button>
      </a>
      <a href={pintrestShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <PinterestIcon fontSize="large" />
        </Button>
      </a>
      <a href={linkedinShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <LinkedInIcon fontSize="large" />
        </Button>
      </a>
      <a href={redditShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <RedditIcon fontSize="large" />
        </Button>
      </a>
      <a href={mailToUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <EmailIcon fontSize="large" />
        </Button>
      </a>
      <a href={telegramShareUrl} target="_blank" rel="noopener noreferrer">
        <Button variant="contained" sx={button}>
          <TelegramIcon fontSize="large" />
        </Button>
      </a>
    </Box>
  );
};

export default SocialShareButtons;
